<div style="display: flex;" data-cy="recent-patients-component">
  <div style="flex: 1; min-height: 200px; height: fit-content; max-height: 600px; margin-bottom: var(--margin-size);" data-cy="recent-patients-container">
    <mat-spinner class="loading-spinner" *ngIf="isLoading" [diameter]="50" data-cy="recent-patients-loading"></mat-spinner>
    <div class="patient-cells" style="margin-top: 2px; margin-bottom: 4px; max-height: 600px;" data-cy="recent-patients-list">
      <div *ngFor="let appt of recentPatients" class="patient-cell" style="cursor: pointer;" (click)="changePatient(appt)" data-cy="recent-patient-item-{{appt.patientId}}">
        <div style="display: flex;" data-cy="recent-patient-content">
          <div style="flex-basis: fit-content;" data-cy="recent-patient-image-container">
            <img [attr.src]="appt.patientImageUrl" style="width: 32px; height: 32px; border-radius: 6px; border: 1px solid #cccccc;" data-cy="recent-patient-image">
          </div>
          <div style="flex: 1; color: black; line-height: 1.2; margin-left: 12px; margin-right: 12px;overflow: hidden;" data-cy="recent-patient-details">
            <div style="font-size: 14px; font-weight: 500;" data-cy="recent-patient-name">
              {{getName(appt)}}
            </div>
            <div style="font-size: 12px; margin-top: 2px;" data-cy="recent-patient-contact">
              {{getContact(appt)}}
            </div>
            <div style="font-size: 12px; margin-top: 2px;" data-cy="recent-patient-address">
              {{getAddress(appt)}}
            </div>            
          </div>          
        </div>
      </div>
    </div>
  </div>
</div>
